module.exports = __webpack_public_path__ + "static/media/signin-left-image.1141f4c4.svg";